var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButton2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#006AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.9002H21.9V22.0002V28.0002C21.9 29.0495 21.0493 29.9002 20 29.9002C18.9507 29.9002 18.1 29.0495 18.1 28.0002V22.0002V21.9002H18H12C10.9507 21.9002 10.1 21.0495 10.1 20.0002C10.1 18.951 10.9507 18.1002 12 18.1002H18H18.1V18.0002V12.0002C18.1 10.951 18.9507 10.1002 20 10.1002C21.0493 10.1002 21.9 10.951 21.9 12.0002V18.0002V18.1002H22H28C29.0493 18.1002 29.9 18.951 29.9 20.0002C29.9 21.0495 29.0493 21.9002 28 21.9002H22Z",
    fill: "white",
    stroke: "#006AFF",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton2);
export default __webpack_public_path__ + "static/media/Button (2).84c03c211d9cb3d8463f54bac0d336f4.svg";
export { ForwardRef as ReactComponent };